import bowser from 'bowser';

if (bowser.ios) {
  document.documentElement.classList.add('ios');
}

if (bowser.safari && bowser.ios) {
  document.documentElement.classList.add('safari-ios');
}
